import * as CardPlatform from '@/src/experiences/card-platform'
import * as Highnote from './highnote'
import * as Platform from './platform'

const LegacyHome = CardPlatform.Screens.Gate({
  Platform: Platform.HomeIndex,
  Highnote: Highnote.HomeIndex,
})

export function HomeIndex() {
  return <LegacyHome />
}
